// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"29":"46f546e1","103":"70feb865","155":"466e9b2d","194":"f4a16554","785":"b7c20941","990":"e35e6ce9"}[chunkId] + ".js";
};